import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { apiClient } from "@/lib/apiClient";
import { apiPath } from "@/lib/apiPath";
import type { ClientPackage } from "../../../lib/packages";

// Same clean instance as the appointments hook: the explicit client token must win.
const clientApi = axios.create();

/** The client's packages (abonements) at this salon — boona GET /public/client/abonements. */
export function useClientAbonements(accessToken: string | null) {
    return useQuery({
        queryKey: ["client", "abonements"],
        queryFn: async (): Promise<ClientPackage[]> => {
            const baseURL = apiClient.defaults.baseURL || "";
            const { data } = await clientApi.get(baseURL + apiPath("/public/client/abonements"), {
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            return Array.isArray(data?.data) ? data.data : [];
        },
        enabled: !!accessToken,
        staleTime: 60_000,
    });
}
